// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2TIDh","form":"styles_form__7vwY_"};